import { component } from 'picoapp';
import Modal from 'utils/modal';
import SwiperClass from 'swiper/types/swiper-class';
import { SwiperOptions } from 'swiper/types/swiper-options';

export default component(async (node) => {
  const sliderElement: HTMLElement = node.querySelector('[data-lightbox-slider]');
  const prev: HTMLButtonElement = node.querySelector('[data-prev]');
  const next: HTMLButtonElement = node.querySelector('[data-next]');

  document.body.appendChild(node);
  const modal = Modal(node);

  let swiperSlider: SwiperClass;
  let index: number = 0;

  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    const trigger: HTMLElement = target.closest('[data-lightbox]');
    const close: HTMLButtonElement = target.closest('[data-close]');
    const breakpoint = window.matchMedia('(min-width: 768px)');

    if (breakpoint.matches) {
      if (trigger) {
        modal.open();
        index = parseInt(trigger.dataset.lightbox, 10);
      }
    }

    if (close) {
      modal.close();
    }
  });

  modal.on('open', async () => {
    const Swiper = (await import(
      /* webpackChunkName: "swiper" */
      'modules/swiper'
    )).default;

    swiperSlider = new Swiper(sliderElement, {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
    } as SwiperOptions);

    swiperSlider.init();
    swiperSlider?.slideTo(index + 1, 0);
  });
});
